[
  {
    "code": "NA-CA",
    "name": "Caprivi"
  },
  {
    "code": "NA-ER",
    "name": "Erongo"
  },
  {
    "code": "NA-HA",
    "name": "Hardap"
  },
  {
    "code": "NA-KA",
    "name": "Karas"
  },
  {
    "code": "NA-KH",
    "name": "Khomas"
  },
  {
    "code": "NA-KU",
    "name": "Kunene"
  },
  {
    "code": "NA-OW",
    "name": "Ohangwena"
  },
  {
    "code": "NA-OK",
    "name": "Okavango"
  },
  {
    "code": "NA-OH",
    "name": "Omaheke"
  },
  {
    "code": "NA-OS",
    "name": "Omusati"
  },
  {
    "code": "NA-ON",
    "name": "Oshana"
  },
  {
    "code": "NA-OT",
    "name": "Oshikoto"
  },
  {
    "code": "NA-OD",
    "name": "Otjozondjupa"
  }
]